import { useCallback, useContext, useMemo } from 'react';
import useBranches from '@ubeya/shared/hooks/account/useBranches';
import useBranchGroups from '@ubeya/shared/hooks/account/useBranchGroups';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import {
  extractBranchIdsOptions,
  filterGroupedBranchOption,
  getGroupedBranchesOptions,
  getGroupedBranchOptionStyle,
  isBranchGroupHeaderOption
} from '../utils/branches';

const useGroupedBranchesOptions = ({ isGroupSelectable = false, selectedBranchIds } = {}) => {
  const { t } = useContext(ConfigContext);
  const { branchesOptions } = useBranches();
  const { branchGroups } = useBranchGroups();

  const groupedBranchesOptions = useMemo(
    () =>
      getGroupedBranchesOptions({
        branchesOptions,
        branchGroups,
        noGroupLabel: t('noGroup'),
        isGroupSelectable,
        selectedBranchIds: selectedBranchIds || []
      }),
    [branchGroups, branchesOptions, isGroupSelectable, selectedBranchIds, t]
  );

  const isGrouped = useMemo(() => groupedBranchesOptions.some(isBranchGroupHeaderOption), [groupedBranchesOptions]);

  const getOptionSpecificStyle = useCallback(
    (option) => (isGrouped ? getGroupedBranchOptionStyle(option) : undefined),
    [isGrouped]
  );

  const expandBranchIds = useCallback((value) => extractBranchIdsOptions(value || [], branchesOptions), [
    branchesOptions
  ]);

  return {
    branchesOptions,
    groupedBranchesOptions,
    getOptionSpecificStyle,
    filterFunc: isGrouped ? filterGroupedBranchOption : undefined,
    expandBranchIds
  };
};

export default useGroupedBranchesOptions;
